import React, { Component } from 'react';
import logo from './logo.svg';
import './styles/App.css';
import Main from './components/MainComponent';
import Header from './components/HeaderComponent';
import Footer from './components/FooterComponent';
import AppRouter from './components/AppRouter';

class App extends Component {
  render() {
    return (
      <section className="">
        <Header />
        <AppRouter></AppRouter>
      </section>
    );
  }
}

export default App;
